<template>
  <div class="repairSucess-container">
    <div class="repairSucess-main">
      <i class="el-icon-success"></i>
      <p class="font-format-normal">{{ msg }}</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      msg: ''
    }
  },
  methods: {},
  mounted() {
    if (this.$route.query.submitStatus) {
      if (this.$route.query.submitStatus === 0) {
        this.msg = '寄修单提交成功！'
      } else if (this.$route.query.submitStatus === -1) {
        this.msg =
          '提交成功！如未填写物流单号的，可在获取之后通过服务进度入口使用收货手机登录，完善信息。'
      }
    } else {
      this.msg = '寄修单提交成功！'
    }
  }
}
</script>

<style lang="scss" scoped>
.repairSucess-container {
  width: 100%;
  padding: 100px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  .repairSucess-main {
    text-align: center;
    > i {
      font-size: 50px;
      color: #67c23a;
    }
    > p {
      color: #67c23a;
      margin-top: 10px;
    }
  }
}
</style>
